import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "vehicleSelect" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.1 11.9H21.55C21.7975 11.9 22 12.1025 22 12.35V13.25C22 13.4975 21.7975 13.7 21.55 13.7H20.2C20.2 15.1906 18.9906 16.4 17.5 16.4C16.0094 16.4 14.8 15.1906 14.8 13.7H11.5V8.05748C11.5 7.64747 11.002 7.4476 10.7431 7.73607L4.99167 13.6519C4.42015 13.4948 4 12.9713 4 12.35V3.35C4 2.60469 4.60469 2 5.35 2H14.35C15.0953 2 15.7 2.60469 15.7 3.35V4.7H16.9403C17.2975 4.7 17.6406 4.84344 17.8937 5.09656L20.7034 7.90625C20.9566 8.15938 21.1 8.5025 21.1 8.85969V11.9ZM16.15 13.7C16.15 14.4453 16.7547 15.05 17.5 15.05C18.2453 15.05 18.85 14.4453 18.85 13.7C18.85 12.9547 18.2453 12.35 17.5 12.35C16.7547 12.35 16.15 12.9547 16.15 13.7ZM15.7 9.2H19.75V8.85969L16.9403 6.05H15.7V9.2Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M3.63278 15.0496C3.34598 15.3291 3.5576 15.8281 3.94528 15.8281H6.59738L5.2016 19.228C5.10438 19.4637 5.21548 19.7279 5.4377 19.8279L6.66683 20.3636C6.89595 20.4636 7.1529 20.3493 7.25013 20.1208L8.57645 16.8924L10.7431 19.1208C11.0318 19.4177 11.5 19.1888 11.5 18.7994V8.05747C11.5 7.64747 11.002 7.4476 10.7431 7.73607L3.63278 15.0496ZM9.6518 6.70669L2.56734 13.9937C1.33259 15.2264 2.23672 17.3281 3.94528 17.3281H4.36007L3.81494 18.656C3.81469 18.6566 3.81445 18.6572 3.8142 18.6578C3.81413 18.6579 3.81428 18.6576 3.8142 18.6578C3.40593 19.651 3.87132 20.768 4.82216 21.1958L4.83027 21.1995L6.06682 21.7384C6.06706 21.7385 6.06658 21.7383 6.06682 21.7384C7.1201 22.1976 8.23316 21.6419 8.63045 20.7079L8.63408 20.6994L9.09497 19.5775L9.66757 20.1665C10.2883 20.8048 11.1659 20.8906 11.8444 20.5858C12.4916 20.2951 13 19.6323 13 18.7994V8.05747C13 6.43959 10.9356 5.32062 9.6518 6.70669Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }